import * as React from "react";
import { SVGProps, memo } from "react";

const SvgSendPrescription = (props: SVGProps<SVGSVGElement>) => (
  <svg width={76} height={54} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path fill="#E5E5E5" d="M0 0h76v54H0z" />

    <g clipPath="url(#SendPrescription_svg__a)">
      <path fill="#F4F7FA" d="M-50-930h375V611H-50z" />

      <path fill="#fff" d="M-50-216h375v599H-50z" />

      <rect x={-34} y={-95} width={343} height={328} rx={10} fill="#E7F4FD" />

      <rect x={-24} y={-24} width={323} height={247} rx={10} fill="#fff" />

      <mask
        id="SendPrescription_svg__b"
        maskUnits="userSpaceOnUse"
        x={21.66}
        y={36}
        width={6}
        height={9}
        fill="#000"
      >
        <path fill="#fff" d="M21.66 36h6v9h-6z" />

        <path d="m22.66 37 3.309 3.11-3.309 3.106V37Z" />
      </mask>

      <path d="m22.66 37 3.309 3.11-3.309 3.106V37Z" fill="#1395EC" />

      <path
        d="m22.66 37 3.309 3.11-3.309 3.106V37Z"
        stroke="#1395EC"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
        mask="url(#SendPrescription_svg__b)"
      />

      <g opacity={0.5}>
        <mask
          id="SendPrescription_svg__c"
          maskUnits="userSpaceOnUse"
          x={16.5}
          y={36}
          width={6}
          height={9}
          fill="#000"
        >
          <path fill="#fff" d="M16.5 36h6v9h-6z" />

          <path d="m17.5 37 3.309 3.11-3.309 3.106V37Z" />
        </mask>

        <path d="m17.5 37 3.309 3.11-3.309 3.106V37Z" fill="#1395EC" />

        <path
          d="m17.5 37 3.309 3.11-3.309 3.106V37Z"
          stroke="#1395EC"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
          mask="url(#SendPrescription_svg__c)"
        />
      </g>

      <g opacity={0.25}>
        <mask
          id="SendPrescription_svg__d"
          maskUnits="userSpaceOnUse"
          x={11.34}
          y={36}
          width={6}
          height={9}
          fill="#000"
        >
          <path fill="#fff" d="M11.34 36h6v9h-6z" />

          <path d="m12.34 37 3.308 3.11-3.308 3.106V37Z" />
        </mask>

        <path d="m12.34 37 3.308 3.11-3.308 3.106V37Z" fill="#1395EC" />

        <path
          d="m12.34 37 3.308 3.11-3.308 3.106V37Z"
          stroke="#1395EC"
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
          mask="url(#SendPrescription_svg__d)"
        />
      </g>

      <path d="M33.5 42h37v12h-37V42Z" fill="#E7F4FD" />

      <path
        d="M34.3 11a3.2 3.2 0 0 1 3.2-3.2h29a3.2 3.2 0 0 1 3.2 3.2v42.2H34.3V11Z"
        stroke="#2B323B"
        strokeWidth={1.6}
      />

      <path
        d="M47.95 16.654v.297h2.389c.442 0 .723-.017 1.011-.05v.994a10.395 10.395 0 0 0-1.087-.051h-1.556c.68.425 1.59.723 2.771.901-.212.306-.331.527-.519.977-1.453-.357-2.142-.68-3.034-1.41.017.161.034.365.034.45v.306c0 .34.008.518.051.714h-1.164c.034-.221.05-.433.05-.723v-.289c0-.059.009-.203.026-.433-.416.374-.807.62-1.428.893-.416.186-.765.305-1.428.492a3.758 3.758 0 0 0-.578-.943c1.105-.187 1.93-.476 2.686-.935h-1.437c-.425 0-.756.017-1.079.051v-.994c.255.034.535.05.944.05h2.295v-.297h-.374c-.306 0-.485.009-.748.034.025-.212.034-.433.034-.74v-1.377c0-.288-.009-.492-.034-.722.246.025.39.034.756.034h.272c.085-.187.119-.314.178-.527l1.038.102c-.085.178-.128.28-.213.425h.587c.356 0 .492-.008.748-.034a5.939 5.939 0 0 0-.035.731v1.122l.587-.68-.468-.553c.646-.425.935-.654 1.233-.994l.757.731c-.536.45-.85.68-1.242.91.587.297.885.484 1.386.867l-.604.841c-.62-.502-.994-.757-1.649-1.097v.23c0 .323.009.518.035.731a7.018 7.018 0 0 0-.748-.034h-.443Zm-1.249-1.734h1.521v-.323h-1.521v.323Zm0 .697v.314h1.521v-.314h-1.521Zm-1.148-3.298v-.043c0-.17-.008-.322-.033-.467h1.113a2.352 2.352 0 0 0-.034.459v.051h1.7v-.051c0-.196-.008-.315-.034-.459h1.114a2.623 2.623 0 0 0-.035.468v.042h1.003a9.34 9.34 0 0 0 1.046-.051v1.003a8.449 8.449 0 0 0-1.003-.051h-1.046v.068c0 .17.009.238.035.4h-1.037c.017-.136.025-.205.025-.383v-.085h-1.836v.076c0 .179 0 .256.026.383h-1.029a3.09 3.09 0 0 0 .026-.408v-.051h-.91a8.55 8.55 0 0 0-1.003.051v-1.003c.323.034.604.051 1.037.051h.876Zm-.059 2.686.28.875c-.62.4-.62.4-1.759.944l-.416-.995c.501-.102 1.207-.416 1.895-.824Zm-1.819-.893.697-.646c.502.324.833.596 1.19.953l-.731.705a6.525 6.525 0 0 0-1.156-1.011Zm14.593 2.925v1.079c0 .314 0 .433.017.561.085.009.128.009.162.009.288 0 .356-.085.441-.51.102-.519.145-1.02.179-2.227h-4.769c-.068.977-.136 1.496-.255 2.031a6.112 6.112 0 0 1-.756 1.845 4.3 4.3 0 0 0-.901-.953c.374-.569.578-1.147.706-1.98.136-.901.203-2.1.203-3.825 0-.536-.008-.723-.05-1.003.314.034.629.051 1.156.051h4.377c.425 0 .74-.008 1.029-.043-.018.196-.026.4-.026.757v.994c0 .374 0 .553.026.732a14.698 14.698 0 0 0-.97-.026H54.35l-.008.485h5.091c.417 0 .596-.009.816-.034 0 .034 0 .067-.008.085-.017.204-.034.518-.077 1.309-.067 1.495-.212 2.405-.441 2.805-.23.399-.519.51-1.343.51-.136 0-.255 0-.715-.026-.059-.425-.119-.672-.229-.96h-1.666v.45h-1.096c.025-.23.033-.425.033-.663v-1.513a4.59 4.59 0 0 0-.025-.587c.196.017.357.026.672.026h2.303c.306 0 .459-.009.638-.026a6.31 6.31 0 0 0-.026.646Zm-3.91-3.434h4.36v-.536h-4.36v.535Zm1.411 3.671v.553h1.462v-.553h-1.462Z"
        fill="#0F72BD"
      />

      <path d="M33.5 41h37v1.6h-37V41Z" fill="#2B323B" />

      <mask
        id="SendPrescription_svg__e"
        maskUnits="userSpaceOnUse"
        x={43.5}
        y={26}
        width={13}
        height={13}
        fill="#000"
      >
        <path fill="#fff" d="M43.5 26h13v13h-13z" />

        <path d="M46.418 36.014c1.312 1.315 3.41 1.315 4.634 0l2.448-2.367-1.399-2.192.175-.088-.35-.263-.175-.263-.087.088L48.866 29l-2.448 2.455c-1.224 1.227-1.224 3.244 0 4.559Z" />
      </mask>

      <path
        d="M46.418 36.014c1.312 1.315 3.41 1.315 4.634 0l2.448-2.367-1.399-2.192.175-.088-.35-.263-.175-.263-.087.088L48.866 29l-2.448 2.455c-1.224 1.227-1.224 3.244 0 4.559Z"
        fill="#fff"
      />

      <path
        d="M46.418 36.014c1.312 1.315 3.41 1.315 4.634 0l2.448-2.367-1.399-2.192.175-.088-.35-.263-.175-.263-.087.088L48.866 29l-2.448 2.455c-1.224 1.227-1.224 3.244 0 4.559Z"
        stroke="#2B323B"
        strokeWidth={3.2}
        mask="url(#SendPrescription_svg__e)"
      />

      <mask
        id="SendPrescription_svg__f"
        maskUnits="userSpaceOnUse"
        x={45.5}
        y={22}
        width={15}
        height={15}
        fill="#000"
      >
        <path fill="#fff" d="M45.5 22h15v15h-15z" />

        <path d="M50.905 31.595 53.222 34l1.781-1.782 2.495-2.494c1.336-1.337 1.336-3.475 0-4.722-1.337-1.336-3.475-1.336-4.722 0l-2.494 2.495-1.782 1.781 2.405 2.317Z" />
      </mask>

      <path
        d="M50.905 31.595 53.222 34l1.781-1.782 2.495-2.494c1.336-1.337 1.336-3.475 0-4.722-1.337-1.336-3.475-1.336-4.722 0l-2.494 2.495-1.782 1.781 2.405 2.317Z"
        fill="#0F72BD"
      />

      <path
        d="M50.905 31.595 53.222 34l1.781-1.782 2.495-2.494c1.336-1.337 1.336-3.475 0-4.722-1.337-1.336-3.475-1.336-4.722 0l-2.494 2.495-1.782 1.781 2.405 2.317Z"
        stroke="#2B323B"
        strokeWidth={3.2}
        mask="url(#SendPrescription_svg__f)"
      />

      <path
        d="M28.04 7.242v22.771c0 .506-.408.91-.916.91H5.223a.909.909 0 0 1-.916-.91V.91c0-.505.407-.909.916-.909h15.505l7.312 7.242Z"
        fill="#F8FAFB"
      />

      <path d="M20.5 1.5V8H27l-6.5-6.5Z" fill="#1395EC" />

      <mask id="SendPrescription_svg__g" fill="#fff">
        <path d="M28.04 7.242v22.771c0 .506-.408.91-.916.91H5.223a.909.909 0 0 1-.916-.91V.91c0-.505.407-.909.916-.909h15.505l7.312 7.242Z" />
      </mask>

      <path
        d="M28.04 7.242v22.771c0 .506-.408.91-.916.91H5.223a.909.909 0 0 1-.916-.91V.91c0-.505.407-.909.916-.909h15.505l7.312 7.242Z"
        stroke="#2B323B"
        strokeWidth={3.2}
        mask="url(#SendPrescription_svg__g)"
      />

      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.5 16h-15v-1h15v1ZM16.5 13h-8v-1h8v1ZM23.5 19h-15v-1h15v1Z"
        fill="#C2CCD6"
      />

      <path d="M26.5 8h-5.247c-.418 0-.753-.39-.753-.88V1" stroke="#2B323B" strokeWidth={1.6} />

      <path d="M74.5 53.2h-73" stroke="#2B323B" strokeWidth={1.6} strokeLinecap="round" />
    </g>

    <defs>
      <clipPath id="SendPrescription_svg__a">
        <path fill="#fff" transform="translate(-50 -930)" d="M0 0h375v1541H0z" />
      </clipPath>
    </defs>
  </svg>
);

const Memo = memo(SvgSendPrescription);

export default Memo;
